import { __drawPoly } from "./polygon.js";
export const polyline = (ctx, attribs, pts) => {
    if (pts.length < 2 || attribs.stroke == "none")
        return;
    __drawPoly(ctx, pts);
    ctx.stroke();
};
